let authenticated = false;
let hasAccessToQuote = false;
let token = {
	Access: '',
	Refresh: ''
};
let decoded = null;
let refreshInterval = null;
const userInfo = {
	user: null,
	photo: null,
	browserInfo: null,
	workingCompany: null,
	availableCompanies: [],
	appIsBusy: false
};

let version = null;
let setUserPromise = null;
let isLocal = __DEBUG__ && false;
let userLocationPromise = null;
let clientProcessId = null;

import _ from 'lodash';
import Promise from 'bluebird';
import $ from 'jquery';
import storage from 'storage';
import jwt_decode from 'jwt-decode';
import moment from 'moment';
import Data from 'app-core/Data';
import config from 'app-core/config';
import locale from 'locale';
import qs from 'query-string';
import signalr from 'app-core/signalr';

export default {
	loadVersion() {
		if (__DEBUG__)
			window.auth = this;
		if (isLocal) {
			version = '0.0.0.0-fake';
			return Promise.resolve(version);
		}
		Data.callMethod('getInfo').then(r => {
			if (__DEBUG__)
				console.debug('App info', { r });

			version = r.version;
		});
	},
	setUserInfo(log) {
		if (!setUserPromise) {
			if (__DEBUG__)
				console.debug('Set user info', log);
			userInfo.user = {};
			Data.getBrowserInfo().then(info => userInfo.browserInfo = info);
			setUserPromise = new Promise((resolve, reject) => {
				return Data.getCurrentUserProfile().then(user => {
					if (user.Success === false)
						reject(new Error(user.ErrorMessage));
					if (__DEBUG__)
						console.debug('User profile loaded', { user });
					userInfo.user = user;
					userInfo.photo = Data.getCurrentUserPhoto();
					if (!userInfo.user.Contact) {
						userInfo.user.Contact = {};
					}
					if (!userInfo.user.Contact.Company) {
						userInfo.user.Contact.Company = {
							Country: {}
						};
					}
					hasAccessToQuote = user && !!user.QuoteApiUrl;
					if (user) {
						if (config?.eventsBus) {
							config.eventsBus.$emit('login');
						}
						Data.callMethod('getConfig', { name: user.AdthosConfigName || 'default' }).then(async (r) => {
							if (__DEBUG__)
								console.log('Config loaded', r);
							config.setConfig(r);
							signalr.initSignalR();
							if (r.settings.language && locale.vueI18n.locale !== r.settings.language && !this.isPublishMode()) {
								if (__DEBUG__)
									console.debug('Language set', locale.vueI18n.locale);
								locale.vueI18n.locale = r.settings.language;
							}

							userInfo.availableCompanies = [];
							const companyId = decoded?.WorkingOnBehalfOfCompany || user?.Contact?.Company?.Oid;
							if (companyId) {
								userInfo.availableCompanies.push({
									..._.pick(user?.Contact?.Company, ['Oid', 'Name']),
									token
								});
								const company = await Data.getExternalApi('Company/GetCompany', `companyId=${user?.Contact?.Company?.Oid}`);
								if (company) {
									_.assign(user?.Contact?.Company, company);
								}
								let workingCompany = company;
								if (workingCompany?.Oid !== decoded?.WorkingOnBehalfOfCompany && decoded?.WorkingOnBehalfOfCompany) {
									workingCompany = await Data.getExternalApi('Company/GetCompany', `companyId=${decoded?.WorkingOnBehalfOfCompany}`);
								}
								userInfo.workingCompany = workingCompany;
							}

							if (!this.isPublishMode()) {
								Data.getExternalApi('Security/GetAvaliableForLoginCompanies').then(r => {
									if (r?.length) {
										userInfo.availableCompanies.push(...r);
									}
								});
							}
							resolve(user);
						}).catch(ex => reject(ex));
					} else {
						reject(new Error('User profile was not loaded successfully'));
					}
					return user;
				}).catch((ex) => {
					setUserPromise = null;
					if (__DEBUG__)
						console.debug('Ser user info catch', ex);
					reject(new Error(ex));
				});
			}).catch(f => {
				setUserPromise = null;
				userInfo.user = null;
			});
		}
		return setUserPromise;
	},
	authenticated() {
		return authenticated;
	},
	refreshToken(timeoutRefresh) {
		if (this.$refreshTokenPromise) return this.$refreshTokenPromise;
		if (__DEBUG__)
			console.debug('Refresh token', { token, timeoutRefresh });
		if (isLocal) {
			authenticated = true;
		}

		if (!token && !token.Refresh) return Promise.resolve(null);
		this.$refreshTokenPromise = Data.postExternalApi('Security/UpdateToken', {
			Data: token.Refresh,
			SilentMode: true
		}).then(r => {
			if (__DEBUG__)
				console.debug('Update token', r);
			if (r && r.Access && r.Refresh) {
				token.Access = r.Access;
				token.Refresh = r.Refresh;
				this.setUserInfo('refreshToken');
				return token;
			} else {
				if (__DEBUG__)
					console.debug('Expired/incorrect token');
				if (timeoutRefresh) {
					throw ('Expired/incorrect token');
				}
				return null;
			}
		}).catch(() => {
			authenticated = false;
			this.clearToken();
			this.logOut();
			if (timeoutRefresh) {
				config.notify('Your session has expired. Please relogin.', 'error', 5000);
				setImmediate(() => {
					config.getVueApp().$router.push({ path: '/login-form' });
				});
			}
		}).finally(() => this.$refreshTokenPromise = null);

		return this.$refreshTokenPromise;
	},
	decodeToken() {
		return new Promise((resolve, reject) => {
			try {
				decoded = jwt_decode(token.Access);
			} catch {
				this.logOut();
				config.getVueApp().$router.push({ path: '/login-form' });
				reject();
				return;
			}
			var expirationDate = moment.unix(decoded.exp);
			var tokenDate = moment.unix(decoded.iat);
			var diffInSec = expirationDate.diff(tokenDate, 'second');
			var timerPeriod = Math.max(diffInSec - 60, 30);
			if (refreshInterval) {
				clearInterval(refreshInterval);
			}
			refreshInterval = setInterval(() => this.refreshToken(true), Math.max(60000, timerPeriod * 1000));
			if (__DEBUG__)
				console.debug('Token decoded', { decoded, exp: expirationDate.toDate(), timerPeriod });
			resolve();
		});
	},
	clearToken() {
		setUserPromise = null;
		Data.clearCache();
		token = {
			Access: null,
			Refresh: null
		};
	},
	logIn(userName, password, rememberUser) {
		if (__DEBUG__)
			console.debug('Login', { userName, rememberUser, headers: __HEADERS__ });
		if (isLocal) {
			authenticated = true;
			token.Access = 'fake';
			token.Refresh = 'fake';
			userInfo.user = {
				HasCreativeApi: true
			};
			return Promise.resolve({
				authenticated: true
			})
		}
		Data.clearCache();
		return new Promise((resolve, reject) => {
			$.ajax({
				url: `${Data.getHostAddress()}/data/login`,
				data: {
					userName, password, lifetime: rememberUser ? 20000 : 20
				},
				headers: {
					...__HEADERS__
				},
				success: (data) => {
					if (__DEBUG__)
						console.log('Auth response', data);
					authenticated = data.Access && data.Refresh;
					token.Access = data.Access;
					token.Refresh = data.Refresh;
					if (authenticated) {
						this.decodeToken().then(() => {
							return this.setUserInfo('logIn').then(() => {
								resolve({ authenticated });
							}).catch((ex) => {
								authenticated = false;
								reject(ex);
							});
						});
						if (__DEBUG__)
							console.log('Authenticated', token);
					} else {
						this.clearToken();
						resolve({ authenticated, errorMessage: data.Message });
					}
				},
				error: () => {
					authenticated = false;
					this.clearToken();
					resolve({ authenticated });
				}
			});
		});
	},
	logOut(saveRememberUser) {
		userInfo.availableCompanies = [];
		setUserPromise = null;
		userInfo.user = null;
		userInfo.photo = null;
		clientProcessId = null;
		authenticated = false;
		userLocationPromise = null;
		if (!saveRememberUser) {
			storage.prop('loginForm_RememberUser', 'root').value = null;
			storage.prop('loginForm_root_company_tokens', 'root').value = null;
		}
		storage.prop('loginForm_RememberMe', 'root').value = false;
		decoded = null;
		Data.clearCache();
		this.clearToken();
		if (refreshInterval) {
			clearInterval(refreshInterval);
		}
	},
	displayUserName() {
		return decoded && decoded.given_name || (userInfo?.user?.Contact ? `${userInfo?.user?.Contact?.Title || ''} <${userInfo?.user?.Contact?.Email}>` : userInfo?.user?.UserName);
	},
	tokens() {
		return token;
	},
	accessToken() {
		return token.Access;
	},
	setAuthenticated(data, skipRefresh) {
		if (__DEBUG__)
			console.debug('Set authenticated', data);
		token = data;
		if (skipRefresh) {
			return this.setUserInfo('setAuthenticated skip').then(() => {
				authenticated = !!token;
				return token;
			});
		}
		return new Promise((resolve, reject) => {
			return this.decodeToken().then(() => {
				if (__DEBUG__)
					console.debug('Refresh token on remember');
				this.refreshToken().then((token) => {
					if (__DEBUG__)
						console.debug('Token refreshed');
					authenticated = !!token;
					if (authenticated)
						this.setUserInfo('setAuthenticated refresh').then(() => {
							resolve(token);
						}).catch(ex => reject(ex));
					else
						resolve(null);
					return token;
				}).catch(ex => {
					authenticated = false;
					reject(ex);
				});
				return null;
			});
		});
	},
	userId() {
		return decoded && decoded.nameid || userInfo?.user?.Oid;
	},
	hasAccessToQuote() {
		return !!hasAccessToQuote;
	},
	data() {
		return decoded;
	},
	userInfo,
	userPhoto(imgOrLink) {
		if (imgOrLink) {
			userInfo.photo = imgOrLink;
			userInfo.user.HasPhoto = true;
		}
		return userInfo.photo;
	},
	canSendInvites() {
		return this.userInfo && this.userInfo.user && (this.userInfo.user.Permissions || []).indexOf('PermissionSendRegistrationInvite') > -1;
	},
	hasAccessToCompanyProfile() {
		return this.isDirector();
	},
	company() {
		return userInfo.workingCompany || {
			Country: {}
		};
	},
	country() {
		return this.company().Country || {};
	},
	countryId() {
		return this.country().Oid || void 0;
	},
	email() {
		return this.userInfo?.user?.Contact?.Email;
	},
	countryCode() {
		return this.country().Code || void 0;
	},
	companyId() {
		return this.company().Oid || void 0;
	},
	contactId() {
		return userInfo?.user?.Contact?.Oid || void 0;
	},
	isAdvertiser() {
		return this.company().CompanyType === 0;
	},
	isStationOwner() {
		return this.company().CompanyType === 1;
	},
	isAgency() {
		return this.company().CompanyType === 2;
	},
	quoteApiUrl() {
		return userInfo?.user?.QuoteApiUrl;
	},
	isAdmin() {
		return userInfo?.user?.IsAdministrator === true;
	},
	isAnonym() {
		return userInfo?.user?.IsAnonym;
	},
	isDirector() {
		return (userInfo?.user?.Permissions || []).indexOf('PermissionDirectorAccess') > -1;
	},
	hasCreativeApi() {
		return userInfo?.user?.HasCreativeApi === true;
	},
	easyCreativeOnly() {
		return userInfo?.user?.easyCreativeOnly === true;
	},
	hasProAudio() {
		return userInfo?.user?.HasProAudio === true;
	},
	hasNetworkStudio() {
		return userInfo?.user?.HasNetworkStudio === true;
	},
	getBrowserLocale() {
		let currentLocale;
		const qsObj = qs.parse(location.search);
		let potentialLocale = qsObj.lang;

		if (!potentialLocale && window.navigator.languages && window.navigator.languages.length) {
			for (let i = 0; i < window.navigator.languages.length; i++) {
				currentLocale = window.navigator.languages[i];
				break;
			}
		}

		return currentLocale;
	},
	environment() {
		return userInfo?.user?.Environment;
	},
	audioApiUrl() {
		return userInfo?.user?.AudioApiUrl;
	},
	getVersion() {
		return version || '';
	},
	isTrial() {
		return userInfo?.user?.IsTrial === true;
	},
	canCreateCreativeTemplate() {
		return userInfo?.user?.CanCreateCreativeTemplate;
	},
	canManageCreatives() {
		return userInfo.user?.Permissions?.includes('ManageCreatives');
	},
	isLocal,
	userIP() {
		return userInfo?.browserInfo?.ip || '';
	},
	isLocalhost() {
		return `${window.location.host}`.startsWith('localhost:');
	},
	allowCreativeStudio() {
		return (userInfo?.user?.AllowCreativeStudio !== void 0 ? userInfo?.user?.AllowCreativeStudio : true) && (!this.isWorkingOnBehalfOfCompany() || this.canManageCreatives());
	},
	restrictedAccess() {
		return ['home', 'user-profile', ...(this.canManageCreatives() ? ['creative-list', 'creative-detail', '/eventRules/List', '/geo-targets/List'] : []) ];
	},
	hasCommonNavigationAccess() {
		return !this.isWorkingOnBehalfOfCompany() || this.isAdmin();
	},
	async switchToCompany(companyId) {
		if (__DEBUG__)
			console.debug('Switch to company', { companyId });

		try {
			userInfo.appIsBusy = true;

			if (companyId === userInfo.user?.Contact?.Company?.Oid) {
				if (storage.prop('loginForm_root_company_tokens', 'root').value) {
					_.assign(token, _.cloneDeep(storage.prop('loginForm_root_company_tokens', 'root').value));
				}
			} else {
				const behalfToken = await Data.getExternalApi('Security/GenerateToken',`lifeTimeInMin=300&loginOnBehalfOfCompany=${companyId}`);
				if (!this.isWorkingOnBehalfOfCompany() && storage.prop('loginForm_RememberMe', 'root').value) {
					storage.prop('loginForm_root_company_tokens', 'root').value = _.cloneDeep(token);
				}
				if (behalfToken?.Access) {
					_.assign(token, behalfToken);
				}
			}

			if (token?.Access) {
				setUserPromise = null;
				await this.decodeToken();
				await this.setAuthenticated(token, true);
			}
		} finally {
			userInfo.appIsBusy = false;
		}
	},
	isWorkingOnBehalfOfCompany() {
		return userInfo.workingCompany?.Oid !== userInfo.user?.Contact?.Company?.Oid;
	},
	canEditPublicObjects() {
		return !!userInfo?.user?.CanEditPublicObjects;
	},
	isPublishMode() {
		return !!config.getVueApp()?.$route?.query?.publicationSession;
	},
	proposalSettings() {
		return {
			onlyMyStations: userInfo?.user?.ProposalOnlyMyStations,
			onlyMyPodcasts: userInfo?.user?.ProposalOnlyMyPodcasts,
			onlyMyStreamings: userInfo?.user?.ProposalOnlyMyStreamings,
		}
	},
	canManageAiMusic() {
		return userInfo?.user?.CanManageAiMusic || this.isAdmin();
	},
	async getUserLocation() {
		if (userLocationPromise) return userLocationPromise;

		userLocationPromise = (async () => {
			let latLon = [];
			let bounds = null;

			var result = await Data.getLocationGeoJson({
				country: this.company()?.Country?.Name,
				city: this.company()?.City
			});

			if (!result?.length) {
				result = await Data.getLocationGeoJson({
					country: this.company()?.Country?.Name,
					state: this.company()?.State,
				});
			}

			if (!result?.length) {
				result = await Data.getLocationGeoJson({
					country: this.company()?.Country?.Name
				});
			}

			if (result?.length) {
				latLon = [parseFloat(result[0].lat), parseFloat(result[0].lon)];
				bounds = result[0]?.boundingbox;
			} else {
				latLon = [37.8, -96];
			}

			if (__DEBUG__)
				console.debug('getUserLocation', { result });

			return {
				latLon,
				bounds
			};
		})();

		return userLocationPromise;
	},
	generateProcessId(prefix) {
		return `${prefix || 'cp'}_${moment().format('hh:mm:ss')}_${Data.uuid()}`;
	},
	getGlobalProcessId(prefix, renew) {
		if (!clientProcessId || renew || (clientProcessId && prefix && !clientProcessId.startsWith(prefix))) {
			clientProcessId = this.generateProcessId(prefix);

			if (__DEBUG__)
				console.debug(`New global process started: ${clientProcessId}`);
		}
		return clientProcessId;
	},
	currentLocale() {
		return locale?.state?.currentLocale?.code || 'en-US';
	}
};
